import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { libraryI18n, commonResources } from '@gofranz/common-components';

// Import gpt-muse-specific translation files
import arUnique from './locales/ar-unique.json';
import deUnique from './locales/de-unique.json';
import enUnique from './locales/en-unique.json';
import esUnique from './locales/es-unique.json';
import frUnique from './locales/fr-unique.json';
import ptUnique from './locales/pt-unique.json';
import thUnique from './locales/th-unique.json';
import zhUnique from './locales/zh-unique.json';

// GPT-Muse-specific resources merged with common translations
// App components need access to common translations (glob_navigation, glob_footer, etc.)
const resources = {
  en: {
    translation: {
      ...commonResources.en,
      ...enUnique,
    },
  },
  de: {
    translation: {
      ...commonResources.de,
      ...deUnique,
    },
  },
  es: {
    translation: {
      ...commonResources.es,
      ...esUnique,
    },
  },
  fr: {
    translation: {
      ...commonResources.fr,
      ...frUnique,
    },
  },
  pt: {
    translation: {
      ...commonResources.pt,
      ...ptUnique,
    },
  },
  zh: {
    translation: {
      ...commonResources.zh,
      ...zhUnique,
    },
  },
  th: {
    translation: {
      ...commonResources.th,
      ...thUnique,
    },
  },
  ar: {
    translation: {
      ...commonResources.ar,
      ...arUnique,
    },
  },
};

// Initialize i18n instance for gpt-muse
// Apps don't use LanguageDetector - they use synchronous init + detectAndSetLanguage in App.tsx
export const i18nInitPromise = i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: typeof window !== 'undefined'
      ? (localStorage.getItem('saved-language') || navigator.language.split('-')[0] || 'en')
      : 'en',
    fallbackLng: 'en',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
  });

// Synchronize language changes between app and library i18n instances
// This ensures library components use the same language as the app
i18n.on('languageChanged', (lng) => {
  libraryI18n.changeLanguage(lng);
});

export default i18n;
